import { createSelector } from '@ngrx/store';
import * as fromApp from '../reducers/app.reducer';
import * as fromAuth from '../reducers/auth.reducer';

const selectAuth = (state: fromApp.AppState) => state.auth;

export const selectAuthIsLoggedIn = createSelector(selectAuth, (state: fromAuth.State) => state.isLoggedIn);

export const selectAuthParsedToken = createSelector(selectAuth, (state: fromAuth.State) => state.parsedToken);

export const selectAuthAccessToken = createSelector(selectAuth, (state: fromAuth.State) => state.accessToken);

export const selectAuthIdentityToken = createSelector(selectAuth, (state: fromAuth.State) => state.idToken);

export const selectAuthTokenExpired = createSelector(
    selectAuth,
    (state: fromAuth.State) => state.isExpired && state.isLoggedIn
);
